export const COMPANY = {
  brand: "PUBBLICELLI",
  legal: "PUBBLICELLI SRLS",
  address: "Via del Trebbio 14, 61043 Cagli (PU), Italia",
  vat: "02568410415",
  sdi: "M5UXCR1",
  phones: [
    { label: "337 645 768", tel: "+39337645768" },
    { label: "342 934 3829", tel: "+393429343829" },
  ],
  emails: ["info@pubblicelli.com", "celliluigi21@gmail.com"],
};

export const CONTACT_PHONE = { label: "337 645768", tel: "+39337645768", wa: "https://wa.me/39337645768" };

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Opportunità", to: "/opportunita" },
  { label: "Come funziona", to: "/come-funziona" },
  { label: "Per le aziende", to: "/per-le-aziende" },
  { label: "Contatti", to: "/contatti" },
];

export const OPP_TYPES = [
  { value: "vendita", label: "Vendita" },
  { value: "affitto", label: "Affitto" },
  { value: "cessione", label: "Cessione attività" },
  { value: "collaborazione", label: "Collaborazione" },
  { value: "altro", label: "Altro" },
];
export const oppTypeLabel = (v) => OPP_TYPES.find((t) => t.value === v)?.label || v;

export const SEARCH_TYPES = ["Casa o appartamento", "Villa", "Casa al mare", "Terreno edificabile", "Attività commerciale", "Immobile commerciale", "Altra opportunità"];

export const FEATURE_FIELDS = {
  residential: [
    { key: "rooms", label: "Locali", type: "number", filter: "rooms_min" },
    { key: "bathrooms", label: "Bagni", type: "number" },
    { key: "surface_sqm", label: "Superficie (m²)", type: "number", filter: "surface_min" },
    { key: "floor", label: "Piano", type: "text" },
    { key: "sea_distance_m", label: "Distanza dal mare (m)", type: "number" },
    { key: "energy_class", label: "Classe energetica", type: "text" },
    { key: "garden", label: "Giardino / spazio esterno", type: "bool" },
    { key: "parking", label: "Posto auto / garage", type: "bool" },
  ],
  land: [
    { key: "land_sqm", label: "Superficie terreno (m²)", type: "number", filter: "land_min" },
    { key: "buildable_mc", label: "Volumetria edificabile (m³)", type: "number" },
    { key: "zoning", label: "Destinazione urbanistica", type: "text" },
  ],
  commercial: [
    { key: "surface_sqm", label: "Superficie (m²)", type: "number", filter: "surface_min" },
    { key: "sector", label: "Settore", type: "text" },
    { key: "street_front", label: "Vetrine su strada", type: "bool" },
    { key: "parking", label: "Parcheggio", type: "bool" },
  ],
  business: [{ key: "sector", label: "Settore", type: "text" }],
  other: [],
};

export const FILTER_LABELS = { rooms_min: "Locali minimi", surface_min: "Superficie minima (m²)", land_min: "Terreno minimo (m²)" };

export const REQUEST_KINDS = { ricerca: "Ricerca", contatto: "Contatto", collaborazione: "Collaborazione", informazioni: "Info opportunità" };
export const REQUEST_STATUS = { nuova: "Nuova", in_lavorazione: "In lavorazione", chiusa: "Chiusa", archiviata: "Archiviata" };
export const VERIFICATION = { in_verifica: "In verifica", verificata: "Verificata", rifiutata: "Rifiutata" };
export const PUBLICATION = { bozza: "Bozza", pubblicata: "Pubblicata", ritirata: "Ritirata" };
export const PARTNER_STATUS = { proposta: "Proposta", in_valutazione: "In valutazione", attiva: "Attiva", sospesa: "Sospesa", conclusa: "Conclusa" };
export const CAT_KINDS = { residential: "Residenziale", land: "Terreno", commercial: "Commerciale", business: "Aziendale", other: "Altro" };
